// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"765":"production-management","820":"company-profile"}[chunkId] + "." + {"765":"fd44af73","820":"008e8cbb"}[chunkId] + ".css";
};